<section class="container featured portfolio rec-pro disc pb-3 pt-4 mobile-featured-properties">
  <div class="portfolio col-xl-12" style="padding-left: 0px; padding-right: 0px;">
    <div class="popular-properties-mobile" [ngClass]="{'overflow-hidden': placeholder}" data-aos="fade-up"
      data-aos-delay="150">
      <ng-container *ngIf="placeholder || !imagesLoaded">
        <div class="agents-grid properties-cards pb-3">
          <div class="landscapes placeholder-glow">

            <div class="project-single h-popular home-mobile">
              <a class="homes-img">
                <div class="project-inner project-head">
                  <div class="homes">
                    <!-- homes img -->
                    <div class="homes-tag button alt sale placeholder"></div>
                    <svg class="bd-placeholder-img card-img-top" width="100%" height="180"
                      xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder"
                      preserveAspectRatio="xMidYMid slice" focusable="false">
                      <title>Placeholder</title>
                      <rect width="100%" height="100%" fill="#868e96"></rect>
                    </svg>
                  </div>
                </div>
              </a>
              <!-- homes content -->
              <div class="homes-content home-mobile">
                <a>
                  <!-- homes address -->
                  <h3><a class="placeholder col-12"></a>
                  </h3>
                </a>
                <a>
                  <p class="homes-address mb-3">
                    <a class="col-5 placeholder">
                      <i class="fa fa-map-marker vis-hidden"></i><span class="vis-hidden"></span>
                    </a>
                  </p>
                </a>
                <!-- homes List -->
                <div class="price-properties footer pt-3 pb-0">
                  <a class="col-4">
                    <h3 class="title mt-3">
                      <a class="placeholder placeholder-lg"></a>
                    </h3>
                  </a>
                  <div class="compare col-3 placeholder">
                    <button class="vis-hidden button-none">
                    </button>
                    <button class="vis-hidden button-none">
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="agents-grid properties-cards pb-3">
          <div class="landscapes placeholder-glow">

            <div class="project-single h-popular home-mobile">
              <a class="homes-img">
                <div class="project-inner project-head">
                  <div class="homes">
                    <!-- homes img -->
                    <div class="homes-tag button alt sale placeholder"></div>
                    <svg class="bd-placeholder-img card-img-top" width="100%" height="180"
                      xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder"
                      preserveAspectRatio="xMidYMid slice" focusable="false">
                      <title>Placeholder</title>
                      <rect width="100%" height="100%" fill="#868e96"></rect>
                    </svg>
                  </div>
                </div>
              </a>
              <!-- homes content -->
              <div class="homes-content home-mobile">
                <a>
                  <!-- homes address -->
                  <h3><a class="placeholder col-12"></a>
                  </h3>
                </a>
                <a>
                  <p class="homes-address mb-3">
                    <a class="col-5 placeholder">
                      <i class="fa fa-map-marker vis-hidden"></i><span class="vis-hidden"></span>
                    </a>
                  </p>
                </a>
                <!-- homes List -->
                <div class="price-properties footer pt-3 pb-0">
                  <a class="col-4">
                    <h3 class="title mt-3">
                      <a class="placeholder placeholder-lg"></a>
                    </h3>
                  </a>
                  <div class="compare col-3 placeholder">
                    <a class="vis-hidden">
                    </a>
                    <a class="vis-hidden">
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!placeholder && highlightsProperties && highlightsProperties.length > 0">
        <div *ngFor="let property of highlightsProperties; let i = index;" class="agents-grid properties-cards pb-3">
          <div class="landscapes">

            <div class="project-single h-popular home-mobile">
              <a [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)"
                class="homes-img">
                <div class="project-inner project-head">
                  <div class="homes">
                    <!-- homes img -->
                    <div class="homes-tag button alt featured">{{'PROPERTY-FEATURED.TEXT' |
                      translate}}
                    </div>
                    <div *ngIf="property?.cardToShow" class="homes-tag button alt sale">
                      {{property?.cardToShow}}
                    </div>
                    <img [src]="property.media[0].file" (error)="imageError($event)" (load)="imageLoad(i)"
                      alt="Property Image" class="img-responsive fit-cover">
                  </div>
                </div>
              </a>
              <!-- homes content -->
              <div class="homes-content home-mobile">
                <a
                  [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">
                  <!-- homes address -->
                  <h3><a
                      [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">{{property.title}}</a>
                  </h3>
                  <p *ngIf="property.district && property.district != ''" class="homes-address mb-3">
                    <a
                      [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">
                      <i class="fa fa-map-marker"></i><span
                        *ngIf="property.county && property.county != ''">{{property.county}},
                      </span><span>{{property.district}}</span>
                    </a>
                  </p>
                  <p *ngIf="(!property.district || property.district == '') && property?.region"
                    class="homes-address mb-3">
                    <a
                      [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">
                      <i class="fa fa-map-marker"></i><span
                        *ngIf="property.country && property.country != ''">{{property.country}},
                      </span><span>{{property?.region}}</span>
                    </a>
                  </p>
                </a>
                <!-- homes List -->
                <div class="price-properties footer pt-3 pb-0">
                  <a
                    [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)">
                    <h3 class="title mt-3">
                      <a [routerLink]="property.propertyTypeId === 96 ? utilsPropertiesService.generateEnterpriseLink(property.title,property.uniqueId) : utilsPropertiesService.generateRouterLink(property.title,property.uniqueId)"
                        [queryParams]="">{{property.price != 0 && property.price != null ?
                        priceFormat(property.price, property.currency) :
                        't-on-request' | translate}}</a>
                    </h3>
                  </a>
                  <div class="compare">
                    <button (click)="utilsPropertiesService.shareProperty(property)" class="button-none fs-5">
                      <ion-icon src="assets/new-icons/share-social-outline.svg"></ion-icon>
                    </button>
                    <button (click)="saveProperty(property.uniqueId)" class="button-none fs-5">
                      <ion-icon *ngIf="!savedService.isSavedProperty(property.uniqueId)"
                        src="assets/new-icons/heart-outline.svg"></ion-icon>
                      <ion-icon *ngIf="savedService.isSavedProperty(property.uniqueId)"
                        class="heart-icon colored-heart-icon" src="assets/new-icons/heart.svg"></ion-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
